import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconMouseStyle0 = cosmosIconCss;

const CosmosIconMouse$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconMouse extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '22afe71344c744fdbff275b90d63d9920dd1e297', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'eae25187472697135296f44c9785a1c1b31a95c1', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '0115ea9c401650dc12b1bc87ad27c2dd68512a22', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M11 4a3.78 3.78 0 0 0-4 3.54v6.92A3.73 3.73 0 0 0 11 18a3.7 3.7 0 0 0 4-3.79V7.77A3.69 3.69 0 0 0 11 4Zm0 4.25a1.25 1.25 0 1 1 .02-2.5 1.25 1.25 0 0 1-.02 2.5Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconMouseStyle0; }
}, [1, "cosmos-icon-mouse", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-mouse"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-mouse":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconMouse$1);
            }
            break;
    } });
}

const CosmosIconMouse = CosmosIconMouse$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconMouse, defineCustomElement };
